// gerate calendar weeks like this 17. KW 27.04.-03.05.2026 23. KW 20.-26.04.2026 23. KW 28.12.2016.-03.01.2027 using dayjs
import dayjs from "dayjs"

export function getCalendarWeekPeriod(date: Date) {
  const startOfWeek = dayjs(date).startOf("week").toDate()
  const endOfWeek = dayjs(date).endOf("week").toDate()
  const weekNumber = dayjs(date).week()
  const startDay = startOfWeek.getDate().toString().padStart(2, "0")
  const endDay = endOfWeek.getDate().toString().padStart(2, "0")
  const startMonth = (startOfWeek.getMonth() + 1).toString().padStart(2, "0")
  const endMonth = (endOfWeek.getMonth() + 1).toString().padStart(2, "0")
  const startYear = startOfWeek.getFullYear()
  const endYear = endOfWeek.getFullYear()
  return `${weekNumber}. KW ${startDay}.${startMonth === endMonth ? "" : `${startMonth}.`}${startYear === endYear ? "" : `${startYear}`}-${endDay}.${endMonth}.${endYear}`
}
